import formatMixin from "@/mixins/common/formatMixin";
import productsMixin from "@/mixins/common/productsMixin";
import utilMixin from "@/mixins/common/utilMixin";
import translateMixin from "@/mixins/common/translateMixin";
import loggerMixin from "@/mixins/common/loggerMixin";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAngleDown,
  faAngleUp,
  faCaretDown,
  faCheck,
  faCheckCircle,
  faClipboardCheck,
  faCoins,
  faCreditCard,
  faDivide,
  faDrumstickBite,
  faEye,
  faListAlt,
  faMinusSquare,
  faMoneyBillAlt,
  faPaperPlane,
  faPlusSquare,
  faPrint,
  faShoppingBag,
  faShoppingCart,
  faTimesCircle,
  faTrash,
  faArrowCircleLeft
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
// Bootstrap currently only used for little JS/CSS helpers. Should be replaced by native code at some point.
import "bootstrap/js/dist/tab";
import "popper.js";
import Swal from "sweetalert2";
import Vue from "vue";
import VueFirestore from "vue-firestore";
import vSelect from "vue-select";
import App from "./App.vue";
import "./assets/styles/app.scss";
import { auth } from "./firebaseConfig.js";
import vuetify from "./plugins/vuetify";
import "./plugins/i18n";
import i18n from "./plugins/i18n";
import router from "./router";
import Api from "./services";
import store from "./store/index";
import background from "./plugins/background";
import FlagIcon from "vue-flag-icon";

Vue.use(background);
Vue.use(FlagIcon);

// Firebase
Vue.use(VueFirestore, {
  key: "id", // the name of the property. Default is '.key'.
  enumerable: true //  whether it is enumerable or not. Default is true.
});
Vue.use(VueFirestore);
Vue.use(Api, { store });

// Other components
Vue.component("vue-select", vSelect);

library.add(
  faPlusSquare,
  faMinusSquare,
  faAngleDown,
  faAngleUp,
  faCheckCircle,
  faTimesCircle,
  faPaperPlane,
  faClipboardCheck,
  faListAlt,
  faCheck,
  faCreditCard,
  faDivide,
  faDrumstickBite,
  faCoins,
  faEye,
  faShoppingBag,
  faShoppingCart,
  faTrash,
  faCaretDown,
  faMoneyBillAlt,
  faPrint,
  faArrowCircleLeft
);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

// Toast
window.Swal = Swal;
const Toast = Swal.mixin({
  toast: true,
  position: "center",
  showConfirmButton: false,
  timer: 3000
});
window.Toast = Toast;

Vue.mixin({
  mixins: [utilMixin, formatMixin, loggerMixin, productsMixin, translateMixin]
});

// handle page reloads
let app;
// eslint-disable-next-line no-unused-vars
auth.onAuthStateChanged(() => {
  if (!app) {
    new Vue({
      i18n,
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount("#app");
  }
});
